import React, { useEffect, useState } from "react";
import AccessController from "_shared/AccessController";
import { DashGridL2 } from "layouts/dash-grid";
import TopBar from "_shared/Top";
import {
  Box,
  Button,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { toastMessage } from "utils/toastMessage";
import { Toaster } from "react-hot-toast";
import { uploadDocuments } from "_controllers/officer";
import axios from "axios";
import dotenv from "dotenv";
import { useHistory } from "react-router-dom";
import { PageHeader, SectionCard } from "_shared/ui";

dotenv.config();

const Main = () => {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [image, setImage] = useState("");
  const [Values, setValues] = useState({
    documentCategory: "",
    imageUrl: "",
    description: "",
  });
  const [imageLoading, setimageLoading] = useState(false);

  useEffect(async () => {
    const requests = await uploadDocuments();
    setData(requests?.docs);
    setLoading(true);
  }, [message]);

  const { documentCategory, imageUrl, description } = Values;

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("submit", Values, image);

    if (image.type === "application/pdf" || image.type === "video/mp4") {
      const formData = new FormData();
      formData.append("file", image);
      formData.append("fileName", image.name);
      formData.append("description", Values.description);
      formData.append("category", Values.documentCategory);
      // const response = await authAxios()({
      //   url: `/api/v1/document`,
      //   method: "POST",
      //   data: Values,
      // });
      // setMessage(response?.data.message);
      // toastMessage("Location Approved", "success");
      const token = localStorage.getItem("token");
      const config = {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const url = process.env.REACT_APP_REQUEST_ENDPOINT;
      await axios
        .post(`${url}/api/v1/document`, formData, config)
        .then((res) => {
          // setImage("");
          // setMessage(res?.data?.message);
          console.log("object", res);
          toastMessage(res?.data?.message, "success");
          history.push("/upload-documents");
        })
        .catch((err) => {
          // comment setImage bcoz with catch page wont refresh
          setImage("");
          setMessage(err?.message);
          toastMessage("Select File First.", "error");
        });
    } else {
      return alert("Upload PDF or Video File Only.");
    }
  };

  const handleChange = (e) => {
    setValues({ ...Values, [e.target.name]: e.target.value });
  };

  const saveImg = async (e) => {
    setImage(e.target.files[0]);
  };

  return (
    <>
      <PageHeader
        title="Create Document"
        subtitle="Upload a PDF or video document and tag it with a category"
      />

      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <SectionCard title="Document Details" sx={{ width: "100%", maxWidth: 820 }}>
          <form onSubmit={handleSubmit}>
            <Grid container spacing={2.5}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  onChange={handleChange}
                  value={documentCategory}
                  name="documentCategory"
                  label="Document Type"
                  variant="outlined"
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  onChange={handleChange}
                  value={description}
                  name="description"
                  label="Description"
                  variant="outlined"
                />
              </Grid>

              <Grid item xs={12}>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={1.5}
                  alignItems={{ xs: "flex-start", sm: "center" }}
                >
                  <Button
                    variant="outlined"
                    component="label"
                    startIcon={<UploadFileIcon />}
                  >
                    Choose File
                    <input type="file" hidden name="image" onChange={saveImg} />
                  </Button>
                  <Typography variant="body2" color="text.secondary">
                    {image?.name || "No file selected (PDF or MP4 only)"}
                  </Typography>
                </Stack>
              </Grid>
            </Grid>

            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 3,
              }}
            >
              <Button type="submit" variant="contained">
                Submit
              </Button>
            </Box>
          </form>
        </SectionCard>
      </Box>
    </>
  );
};

const AddDocument = () => {
  return (
    <AccessController roles={["AO", "RO", "ZO", "ADMIN"]}>
      <DashGridL2 Top={TopBar} Main={Main} />
      <Toaster />
    </AccessController>
  );
};

export default AddDocument;
